/* global Q, o, gettype, dn, allViews, _E */



//(function () {
function shortify(s) {
	var exe = /function .*\(.*?\)\s*{(\s*\[native code\])?/.exec(s);
	return !exe ? s : exe[1] ? exe[0] + " }" : exe[0] + "...}";
}

function list(obj, steps, title_adition) {
	var out = "",
		N = steps || 6;
	var is_template_inpect = false;
	if (gettype(obj).indexOf("HTML") >= 0 || gettype(obj) === "global") N = 1;
	if (obj instanceof template_object) {
		is_template_inpect = true;
	}
	if (steps === 0) {
		out += "<ul class='inspect_list'>";
		for (var v in obj) {
			out += "<li><span>" + v + "</span> : " + gettype(obj[v]) + "</li>";
		}
		out + "</ul>";
	} else

		(function dig(x, n) {
			out += "<ul class='inspect_list' " + (!n ? " top " : "") + ">";

			if (x instanceof Map) {
				x.forEach((val, key) => {
					var type;
					try { type = gettype(val); } catch (err) { type = null; }

					var keyLabel = typeof key === "object"
						? (key?.tagString || gettype(key))
						: key;

					out += "<li><span>" + keyLabel + "</span>: ";
					switch (type) {
						case "Array":
						case "Object":
						case "Map":
						case "Module":
							out += "<div>" + type;
							if (n + 1 < N) dig(val, n + 1);
							out += "</div>";
							break;
						case "Function":
						case "AsyncFunction":
							out += "function(){}";
							break;
						case null:
							out += null;
							break;
						default:
							out += typeof val === "string"
								? "<m item>" + val.replace(/&lt;/gim, "<") + "</m>"
								: val;
					}
					out += "</li>";
				});
			} else {
				for (var i in x) {
					var type;
					try {
						type = gettype(x[i]);
					} catch (err) {
						type = null;
					}
					if (x[i] instanceof template_object) {
						out += "<li><span>" + i + "</span>: <div>" + x[i].name + "</div> <m lc>template_object</m></li>";
					}
					else if (i == 'axon' && x[i] instanceof Neuron) {
						//console.log(i, x[i]);
						out += "<li><span>" + i + "</span>: <div>" + x[i].name + "</div> <m lc>Neuron</m></li>";
					}
					else if (i == 'view' && is_template_inpect) {
						out += "<li><span>" + i + "</span>: <div>" + "</div> <m lc>tpl_obj_component</m></li>";
					}
					else if (i == 'js' && is_template_inpect) {
						out += "<li><span>" + i + "</span>: <div>" + "</div> <m lc>tpl_obj_component</m></li>";
					}
					else if (i == 'css' && is_template_inpect) {
						out += "<li><span>" + i + "</span>: <div>" + "</div> <m lc>tpl_obj_component</m></li>";
					}
					else {
						out += "<li><span>" + i + "</span>: ";
						switch (type) {
							case "Array":
							case "Object":
							case "MutationRecord":
							case "MutationObserver":
							case "Module":
								if (type === "Object") {
									type = x[i] + "" || type;
									if (type === "[object Object]") {
										type = "Object";
									}
								}
								out += "<div>" + type;
								if (n + 1 < N) dig(x[i], n + 1);
								out += "</div>";
								break;
							case "Map":
								try {


									out += "<div>Map(" + x[i].size + ")";
									if (n + 1 < N) dig(x[i], n + 1);
									out += "</div>";
								} catch (error) {
									out += "<div>BUBA</div>";
									console.log(error);
								}
								break;
							case "Function":
							case "AsyncFunction":
								var f2s;
								try {
									var exe = /function .*?\(.*?\)\s*{(\s*\[native code\])?/.exec(x[i]);
									f2s = exe[1] ? exe[0] + " }" : exe[0] + " [aha code] }";
								} catch (err) {
									f2s = "function (){}";
								}
								out += f2s;
								break;
							case "NodeList":
								out += "<div>" + gettype(x[i]);
								if (n + 1 < N) dig([...x[i]], n + 1);
								out += "</div>";
								break;
							case null:
								out += null;
								break;
							default: {
								switch (i) {
									case "innerText":
									case "outerText":
									case "innerHTML":
										out += " ... ";
										break;
									case "outerHTML":
										out += x[i]
											? x[i].match(/<.*?>/)[0].replace(/^</, "&lt;")
											: " ... ";
										break;
									default:
										try {
											out += /Element/.test(gettype(x[i]))
												? x[i].tagString
												: typeof x[i] === "string"
													? "<m item>" + x[i].replace(/&lt;/gim, "<") + "</m>"
													: x[i];
										} catch (e) {
											out += "<m>---</m>";
										}
								}
							}
						}
						out += "</li>";
					}
				}
			}
			out += "</ul>";
		})(obj, 0);

	var tit;
	try {
		tit = title_adition
			? title_adition
			: obj instanceof Map
				? "Map(" + obj.size + ")"
				: gettype(obj) === "Array"
					? "Array"
					: obj + "";
		if (gettype(obj) === "Function") {
			tit = tit.split("{")[0];
		}
	} catch (e) {
		tit = gettype(obj);
	}
	return [out, tit];
}




function _props(o) {
	return Object.getOwnPropertyNames(o)
		.concat(Object.getOwnPropertyNames(Object.getPrototypeOf(o)))
		.unique();
}
Q.o2ul = list;




Q.i = function (x, opt = {}) {

	var code;

	try {
		throw new Error();
	} catch (e) {
		var stack = e.stack.split("\n"),
			code = (stack[2] || stack.last());
		//console.log(opt)
		opt === null && (opt = {});
		opt.trace && console.log(stack);

		let prefix = '';
		try {
			prefix = typeof x === "string" ? "String " : (Array.isArray(x) ? "Array" : x + '');
		} catch (error) {
			prefix = gettype(x);
		}
		prefix = "<m style='color:lime'>" + prefix.replace("\[object", '').replace(/\].*$/, '') + "</m> ";
		//console.log(prefix)

		// PREPARE TITLE OF INSPECTION
		if (/template\.js/.test(code)) { // componenta js a unui template
			let LC = code.match(/ <anonymous>:(\d*):(\d*)/);
			if (LC) {
				let L = LC[1], C = LC[2];

				let tpl_name = opt instanceof template_object ? opt.name : TE.name;
				code = prefix + code.replace(/.*template.js.*$/, tpl_name + ".js" + ":" + (+L - 3) + ":" + C + " <m cmt>VM:" + L + ":" + C) + "</m>";
			}
			else { // template itself
				code = stack[2].replace(/^.*\(/, '').replace(")", "");
			}

		} else if (/evalScripts/.test(code)) { // inline script.run() 
			code = (history.now.interface || history.now.src) + " <m bc>&lt;script/>.run()</m>"
		} else { // normal (href/include)
			if (/<anonymous>:/.test(code)) {
				switch (true) {
					case Array.isArray(x):
						code = "Array"
						break;
					case gettype(x) === "Module":
						code = "Module";
						break;


					default:
						try {
							code = x + ''; // fortez toString
						} catch (error) {
							if (x.constructor) {
								code = x.constructor.name + ".prototype"
							}
							else {
								code = typeof x
							}
						}
						break;
				}
			}
			else {
				let rgx = new RegExp(history.now.tgdb ? ".*" + history.now.tgdb + "/" : ".*" + location.href);
				code = prefix + code.replace(rgx, '/').replace(/\?V=\d*/, ' <m bc>L').replace(/\)$/, '').replace(/at[^\(]*\(https:\//gims, '');
				if (/BAC_LDOM/.test(code)) {
					//console.log(stack)
					code = history.now.interface + ".js  ?:? <m hsp2 bc>.then() </m>" || history.now.src
				}

			}
		}
	}
	code = opt.flag ? "<m style='background:orange;color:initial;padding:0 .2em'>" + opt.flag + "</m>&nbsp;" + code : code;
	code = code.replace(/:\d+:\d+$/g, function (match) { // elimin coloana din linia de cod 
		return match.replace(/:(\d+):(\d+)/, function (m, m1, m2) {
			return " <m bc>:" + m1 + "</m>";
		})
	});

	var out;
	switch (opt.steps || 5) {
		case -1:
			out = dn(list(_props(x))[0], gettype(x));
			break;
		//case 0:dn(list(Object.getOwnPropertyNames(x))[0],gettype(x));break;
		default:
			out =
				typeof x === "string"
					? dn(
						x,
						opt.title || code,
						opt.time || null
					)
					: dn(...list(x, opt.steps, opt.title || code), opt.time || null);
			out.content.setA("inspect_content");
	}
	if (opt.stripe) {
		var lis = out.content.find("ul[top] > li");
		lis.map((li, idx) => {
			var ul = li.last.last;
			li.html = "";
			idx && li._("<hr style='margin:1em 0'/>");
			li._(ul);
		});
	}
	return out;
};

Object.defineProperty(Q, "ip", {
	value: function (r) {
		let R = r.parsed;
		Q.i(R, { flag: "Q.ip", _title: "Q.ip " + history.now.interface + ".js" });
	}
})

var monitor_view;
let wrap = _E().css({
	position: "absolute",
	color: "white",
	font: ".9em monospace",
});

Q.monitor = function (data, opt = {}) {
	//console.trace(__ML__);
	opt === null && (opt = {})
	opt === 1 && (opt = {
		x: body.w - 510,
		y: body.h - 910
	})
	if (!allViews.has(monitor_view)) {
		monitor_view = new View();
		monitor_view.title = "<m yc>JS-MONITOR</m>";
		monitor_view.color = "black";
		monitor_view.content.css({ background: "black" })._(wrap);
		monitor_view.content.on("dblclick", (ev) => {
			wrap.html = "";
		});
		monitor_view.height = opt.height || 700;
		monitor_view.width = opt.width || 400;
		monitor_view.frame.css({
			background: "black",
			color: "white",
			"z-index": "3000000 !important",
			position: "fixed",
			transform: "translate(10,50)",
		});
		setTimeout(() => {
			monitor_view.frame.style.opacity = 0;
			var stored_position = LS.pointer("q_monitor") || { x: 0, y: 0 };
			monitor_view.frame.tail({ x: opt.x || stored_position.x, y: opt.y || stored_position.y });
			monitor_view.frame.fade(1)
		}, 0);

		_E("<m yc style='margin: 0 0 0 1em;font-size:.8em'>JS-MONITOR</m>").oust(
			monitor_view.frame.find("[view_bara_titlu]", 1)
		);
		monitor_view.frame.find("[view_icon]", 1).die();
		//monitor_view.frame.style.transform = 'translate(-1px,100px)';
		//monitor_view.frame.style.right = "0px";
		monitor_view.frame.css(opt.css);
		monitor_view.frame.setA("js_monitor");
		monitor_view.fixed_poz_sw.setA("active");
		monitor_view.link.html = "<m style='color:white'>M</m>";

		monitor_view.frame.on("dragend", ev => {
			LS.pointer("q_monitor", { x: monitor_view.frame.x, y: monitor_view.frame.y - window.scrollY })
		})
	}
	if (opt.add) {
		wrap._("<hr/>");
	} else {
		wrap.html = "";
	}
	if (opt.title) {
		wrap._("<div yc>" + opt.title + "</div><br/>");
	}
	wrap._(list(data, opt.steps || 5)[0]);

	setTimeout(function () {
		wrap.parent.scrollTop = wrap.scrollHeight;
	}, 0);
	return monitor_view
};

Object.defineProperty(Q.monitor, "view", {
	get: function () {
		return monitor_view;
	},
});


Q.trace = function (limit = 15) {
	const error = new Error();
	const stack = error.stack
		.split('\n')          // Split into lines
		.slice(2, limit + 2); // Skip the first two lines (Error message and current function)

	console.log(`Trace:\n${stack.join('\n')}`);
}
//})();




Object.defineProperty(window, '__ML__', {
	get() {
		const stack = new Error().stack;
		const method = stack.split('\n')[2].match(/at (\S+)/);
		const line = stack.split('\n')[2].match(/:(\d+):\d+\)?$/);
		return "__ML__ >>  " + (method ? method[1] : 'anonymous') + " :: " + (line ? Number(line[1]) : -1);
	},

});


